import get from "lodash.get";

import XHTTP from "services/api/xhttp";
import CommonUtils from "services/common/utils";
import paths from "routes/paths";

class CustomAnalysisApi {
  static END_POINTS = {
    getAttendance: () =>
      get(paths, `api.custom_analysis.dataByAreas.attendance`),
    getHourlyAttendance: () =>
      get(paths, `api.custom_analysis.dataByAreas.hourlyAttendance`),
    getAttendanceStats: () =>
      get(paths, `api.custom_analysis.dataByAreas.attendanceStats`),
    getAttendancePeak: () =>
      get(paths, `api.custom_analysis.dataByAreas.attendancePeak`),
    getPressure: () => get(paths, `api.custom_analysis.dataByAreas.pressure`),
  };

  static getAttendance(data, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${CustomAnalysisApi.END_POINTS.getAttendance()}?${queryString}`,
      {
        method: "post",
        body: JSON.stringify(data),
        abortMultiple: false,
      }
    );
  }

  static getHourlyAttendance(data, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${CustomAnalysisApi.END_POINTS.getHourlyAttendance()}?${queryString}`,
      {
        method: "post",
        body: JSON.stringify(data),
        abortMultiple: false,
      }
    );
  }

  static getAttendanceStats(data, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${CustomAnalysisApi.END_POINTS.getAttendanceStats()}?${queryString}`,
      {
        method: "post",
        body: JSON.stringify(data),
        abortMultiple: false,
      }
    );
  }

  static getAttendancePeak(data, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${CustomAnalysisApi.END_POINTS.getAttendancePeak()}?${queryString}`,
      {
        method: "post",
        body: JSON.stringify(data),
        abortMultiple: false,
      }
    );
  }

  static getPressure(data, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${CustomAnalysisApi.END_POINTS.getPressure()}?${queryString}`,
      {
        method: "post",
        body: JSON.stringify(data),
        abortMultiple: false,
      }
    );
  }
}

export default CustomAnalysisApi;
